import AnydeskIcon from "@/components/brand-icons/anydesk";
import ChromeIcon from "@/components/brand-icons/chrome";
import Firefox from "@/components/brand-icons/firefox";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { createFileRoute } from "@tanstack/react-router";
import { DownloadIcon } from "lucide-react";

export const Route = createFileRoute("/useful-links/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>ابزار های کاربردی</CardTitle>
      </CardHeader>

      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <div className="flex flex-col gap-5 items-center justify-center">
            <ChromeIcon />
            <p className="text-xl no-font font-bold">مروگر کروم</p>
            <a href="https://dl.esaj.ir/Google.Chrome.11/Setup.msi" download>
              <Button>
                <DownloadIcon className="ml-2" />
                دانلود نسخه ویندوز ۱۰/۱۱
              </Button>
            </a>
            <a href="https://dl.esaj.ir/Google.Chrome.7/Setup.msi" download>
              <Button>
                <DownloadIcon className="ml-2" />
                دانلود نسخه ویندوز ۷
              </Button>
            </a>
          </div>
          <div className="flex flex-col gap-5 items-center justify-center">
            <Firefox />
            <p className="text-xl no-font font-bold">مروگر فایرفاکس</p>
            <a href="https://dl.esaj.ir/Firefox.11/Setup-142.exe" download>
              <Button>
                <DownloadIcon className="ml-2" />
                دانلود نسخه ویندوز ۱۰/۱۱
              </Button>
            </a>
            <a href="https://dl.esaj.ir/Firefox.7/Setup-115.exe" download>
              <Button>
                <DownloadIcon className="ml-2" />
                دانلود نسخه ویندوز ۷
              </Button>
            </a>
          </div>
          <div className="flex flex-col gap-5 items-center justify-center">
            <AnydeskIcon />
            <p className="text-xl no-font font-bold">برنامه انی دسک</p>
            <a href="https://dl.esaj.ir/AnyDesk/AnyDesk.exe" download>
              <Button>
                <DownloadIcon className="ml-2" />
                دانلود
              </Button>
            </a>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
